import { render, staticRenderFns } from "./PendingSvg.vue?vue&type=template&id=63c6e56c"
import script from "./PendingSvg.vue?vue&type=script&lang=js"
export * from "./PendingSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports